import { authWithPopup, signMessageWithPopup, AuthResponseData } from '@joyid/core'
//import { JoyIDProvider } from '@joyid/ethers';
import { initConfig } from "@joyid/evm";
import { AppSettings } from "../client/AppSettings";
import { Wallet } from './Wallet';
import { ProviderKeys } from '../data/ProviderKeys';

export class JoyIDWallet extends Wallet {
    joyIdInfo?: AuthResponseData;
    
    constructor() {
        super();
        this.walletProvider = ProviderKeys.JoyID;
    }

    async connect(): Promise<string> {
        this.account = "";
        const res = await authWithPopup({
            redirectURL: window.location.origin + '/',
            name: AppSettings.appName,
            challenge: 'Connect with ' + AppSettings.appName,
            logo: AppSettings.appIcon,
        });
        console.log(res);
        // if (res.error == null) {
        //     this.joyIdInfo = res;
        //     this.account = this.joyIdInfo.address;
        //     this.publicKey = this.joyIdInfo.pubkey;
        // }
        this.joyIdInfo = res;
            this.account = this.joyIdInfo.address;
            this.publicKey = this.joyIdInfo.pubkey;

        this.originalAccount = this.account;
        console.log(`Nervos address: ${this.account}`);
        console.log(`publicKey: ${this.publicKey}`);
        return this.account;
    }

    async signMessage(message: string): Promise<string> {
        let signature = "";
        const res = await signMessageWithPopup({
            redirectURL: window.location.origin + '/',
            name: AppSettings.appName,
            challenge: message,
            logo: AppSettings.appIcon,
            address: this.account,
        });
        // if (res.error == null) {
        //     signature = res.data.signature;
        //     this.publicKey = res.data.pubkey;
        // }
        signature = res.signature;
        this.publicKey = res.pubkey;

        return signature;
    }

    async verifyMessage(): Promise<boolean> {
        return false;
    }

}
//public key of CKB: length=128, 64 bytes
//1d1fae26d1429b91c41791f969259f6f6d9d66b3e2c6305980e9b532d03aa183f4f82db3e36d861e83b44bbd83e0eb1aa05def093fb76e0e8098af51b900181b
//42069420694206942069420694206942069420694206942069420694206942069420694206942069420694206942069420694206942069420694206942069420